import Tree from './Tree';
import { Tooltip } from '@material-ui/core';
import { useDrag, useDrop } from 'react-dnd';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import DescriptionIcon from '@material-ui/icons/Description';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Box, Grid, IconButton, makeStyles } from '@material-ui/core';

const ItemTypes = {
	ITEM: 'item',
};

const useStyles = makeStyles({
	boxStyle: {
		paddingLeft: '10px',
		borderRadius: '5px',
		'&:hover': {
			background: '#f5f5f5',
			cursor: 'pointer',
		},
	},
});

export default function Item({
	parent,
	item,
	move,
	find,
	index,
	indexParent,
	onView,
	onDetail,
	onFile,
	onDelete,
}) {
	const classes = useStyles();
	const [, drop] = useDrop({
		accept: ItemTypes.ITEM,
		canDrop: false,
		hover: (draggedItem, monitor) => {
			if (draggedItem.id === item.id || draggedItem.id === parent) return;
			if (!monitor.isOver({ shallow: true })) return;
			move(draggedItem.id, item.id, parent);
		},
	});
	const [, drag, preview] = useDrag({
		type: ItemTypes.ITEM,
		item: {
			id: item.id,
			parent,
			subItems: item.subItems,
		},
		isDragging: (monitor) => item.id === monitor.getItem().id,
	});

	return (
		<div ref={drop}>
			<div ref={preview}>
				<Grid container>
					{item.titulo && (
						<div
							style={{
								width: '80%',
								marginTop: '8px',
								color: 'blue !important',
								fontWeight: 'bold',
								textTransform: 'uppercase',
							}}
						>
							{item.titulo}
						</div>
					)}
				</Grid>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
					}}
					className={classes.boxStyle}
					ref={drag}
				>
					<Box sx={{ flexGrow: 2 }}>{`${item.order} > ${item.name}`}</Box>
					<Box
						sx={{
							display: 'flex',
							flexGrow: 1,
							justifyContent: 'end',
							width: '162px',
						}}
					>
						{onView && (
							<Tooltip title="Ver Detalle">
								<IconButton
									onClick={() => onView(item)}
									color="secondary"
									aria-label="delete"
								>
									<VisibilityIcon />
								</IconButton>
							</Tooltip>
						)}
						{onDetail && (
							<Tooltip title="Editar / Asignar Resolución y Tema">
								<IconButton
									onClick={() => onDetail(item)}
									color="secondary"
									aria-label="delete"
								>
									<EditIcon />
								</IconButton>
							</Tooltip>
						)}
						{onFile && (
							<Tooltip title="Archivos Adicionales">
								<IconButton
									onClick={() => onFile(item)}
									color="secondary"
									aria-label="delete"
								>
									<DescriptionIcon />
								</IconButton>
							</Tooltip>
						)}
						{onDelete && (
							<Tooltip title="Eliminar Punto">
								<IconButton
									onClick={() => onDelete(item)}
									color="primary"
									aria-label="delete"
								>
									<DeleteIcon />
								</IconButton>
							</Tooltip>
						)}
					</Box>
				</Box>
				{item && item?.subItems.length > 0 && (
					<Tree
						parent={item.id}
						items={item.subItems}
						move={move}
						find={find}
						indexParent={index}
						onItemView={onDetail}
						onItemFiles={onFile}
						onItemDelete={onDelete}
						onItemDetail={onView}
					/>
				)}
			</div>
		</div>
	);
}
